module.exports = __webpack_public_path__ + "media/sales/tape-55c549e4.png";